var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11113_58811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.0625 19.2941C5.11539 23.0587 11.625 24.0938 11.625 24.0938C11.625 24.0938 17.327 23.5294 20.5978 20.7058C20.1617 21.0823 18.9624 21.1764 18.4173 21.1764L20.0527 19.7648C20.4889 19.3883 20.9614 18.6666 21.1431 18.3529C22.7786 14.5882 22.2334 12.2353 20.0527 10.3529C20.4889 12.2353 19.5075 12.3922 18.9624 12.2353C17.2179 11.8588 18.4173 8.94118 18.4173 7.05883C18.4173 4.04706 12.9657 0.470587 11.3302 0C11.1485 0.313723 10.8941 1.6 11.3302 4.23529C11.7663 6.87058 10.0582 6.27452 9.14957 5.64705C9.14957 5.96077 9.04054 6.68235 8.60441 7.05883C6.96893 8.47059 7.51408 10.8235 6.96892 12.2353C6.42377 13.6471 5.33346 13.1765 4.7883 12.7059C4.24314 12.2353 4.7883 10.3529 4.24314 10.8235C-0.118135 15.3412 3.15281 19.2941 5.33346 20.7058C4.97003 20.7058 3.807 20.4234 2.0625 19.2941Z",
    fill: "url(#paint0_linear_11113_58811)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0707 23.9934C11.0707 23.9934 10.4237 23.8824 9.28125 23.5312C9.28328 23.5336 9.30953 23.591 9.28125 23.5312C9.18563 23.4564 9.38428 23.6141 9.28125 23.5312C9.04073 23.3681 8.65189 22.9454 8.21155 22.4773C7.07348 21.5634 5.20997 18.2461 7.48611 15.3216C7.77062 15.017 7.48611 16.2356 7.77062 16.5402C8.05513 16.8449 8.62416 17.1495 8.90869 16.2356C9.1932 15.3217 8.90869 13.7985 9.76223 12.8846C9.98983 12.6409 10.0467 12.1737 10.0467 11.9706C10.5209 12.3769 11.4124 12.7627 11.1848 11.0567C10.9572 9.35079 11.4804 8.51802 11.5752 8.31494C12.4287 8.61957 14.8835 10.9349 14.8835 12.8846C14.8835 14.1031 14.2576 15.9919 15.1681 16.2356C15.4525 16.3372 15.9647 16.2356 15.7371 15.017C16.8752 16.2356 17.1596 17.7588 16.3061 20.1959C16.2113 20.399 15.9647 20.8661 15.7371 21.1098L14.625 22.5937C14.2737 22.9698 13.3451 23.7952 13.3125 23.8124C11.8125 24.2812 11.0707 23.9934 11.0707 23.9934Z",
    fill: "url(#paint1_linear_11113_58811)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_11113_58811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.94778 22.5525C10.4913 23.3167 11.4117 23.8125 11.4117 23.8125C11.4117 23.8125 11.8842 23.69 12.2673 23.3553C12.4049 23.2351 12.6828 22.8873 12.829 22.7105L13.1465 22.2661C13.2413 22.1516 13.344 21.9322 13.3834 21.8368C13.7389 20.6913 13.6204 19.9756 13.1465 19.403C13.2413 19.9756 13.028 20.0233 12.9096 19.9757C12.5304 19.8611 12.7911 18.9735 12.7911 18.4009C12.7911 17.4846 11.7689 16.3966 11.4135 16.2534C11.374 16.3489 11.1562 16.7402 11.251 17.5418C11.3457 18.3435 10.9745 18.1622 10.7771 17.9714C10.7771 18.0667 10.7534 18.2863 10.6586 18.4009C10.3032 18.8304 10.4216 19.5461 10.3032 19.9757C10.1847 20.405 9.94778 20.262 9.8293 20.1187C9.71082 19.9757 9.8293 19.403 9.71082 19.5461C8.76304 20.9205 9.47389 22.1229 9.94778 22.5525Z",
    fill: "#FFF4CA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_11113_58811",
    x: 5.24365,
    y: 12.2534,
    width: 12.3467,
    height: 15.5591,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_11113_58811"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11113_58811",
    x1: 12.0783,
    y1: -2.05714,
    x2: 12.0783,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE2E06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F06A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11113_58811",
    x1: 11.5777,
    y1: 7.05725,
    x2: 11.5777,
    y2: 23.9255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBC1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEF64"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11113_58811"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24.5625,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/FIRE.b3943532ec485ab797f704fdefd735cc.svg";
export { ForwardRef as ReactComponent };